<template>
  <div>
    <div>
      <h3 style="text-align: center">平台全交易对通用【暴跌】抄底多梯度配置</h3>
    </div>
    <globbing-configs :order-direction="0"></globbing-configs>
  </div>
</template>

<script>

import GlobbingConfigs from '@/components/platformGlobbingKlineConfig/GlobbingConfigs.vue'

export default {
  name: 'GlobbingConfigsShort',
  components: { GlobbingConfigs },
  data () {
    return {}
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
